export const filterCodes = [
    {
        "dc": 4792,
        "club": 4775,
        "carrierId": "PASC"
    },
    {
        "dc": 4792,
        "club": 4790,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 4837,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 4871,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 4874,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 4990,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 6220,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 6361,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 6435,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 6503,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 6521,
        "carrierId": "PASC"
    },
    {
        "dc": 4792,
        "club": 6527,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8102,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8106,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8114,
        "carrierId": "PASC"
    },
    {
        "dc": 4792,
        "club": 8119,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8151,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8181,
        "carrierId": "PASC"
    },
    {
        "dc": 4792,
        "club": 8192,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8221,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8236,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8261,
        "carrierId": "WM"
    },
    {
        "dc": 4792,
        "club": 8271,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 4720,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 4850,
        "carrierId": "PASC"
    },
    {
        "dc": 4889,
        "club": 4914,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 4939,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 4948,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 4958,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6188,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6245,
        "carrierId": "PASC"
    },
    {
        "dc": 4889,
        "club": 6259,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6262,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6269,
        "carrierId": "PASC"
    },
    {
        "dc": 4889,
        "club": 6336,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6439,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6453,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 6471,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8126,
        "carrierId": "PASC"
    },
    {
        "dc": 4889,
        "club": 8156,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8156,
        "carrierId": "WMT"
    },
    {
        "dc": 4889,
        "club": 8227,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8250,
        "carrierId": "PASC"
    },
    {
        "dc": 4889,
        "club": 8259,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8262,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8264,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8267,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8286,
        "carrierId": "WM"
    },
    {
        "dc": 4889,
        "club": 8288,
        "carrierId": "WM"
    },
    {
        "dc": 4964,
        "club": 4820,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 4866,
        "carrierId": "CRAM"
    },
    {
        "dc": 4964,
        "club": 4866,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 4872,
        "carrierId": "USXI"
    },
    {
        "dc": 4964,
        "club": 4879,
        "carrierId": "USXI"
    },
    {
        "dc": 4964,
        "club": 6203,
        "carrierId": "USXI"
    },
    {
        "dc": 4964,
        "club": 6204,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 6225,
        "carrierId": "CRAM"
    },
    {
        "dc": 4964,
        "club": 6225,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 6270,
        "carrierId": "CRAM"
    },
    {
        "dc": 4964,
        "club": 6270,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 6335,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 6363,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 6506,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 6543,
        "carrierId": "CRAM"
    },
    {
        "dc": 4964,
        "club": 6543,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 6582,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 6680,
        "carrierId": "CRAM"
    },
    {
        "dc": 4964,
        "club": 6680,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 6689,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 6690,
        "carrierId": "SEBG"
    },
    {
        "dc": 4964,
        "club": 7658,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8116,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8120,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8138,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8155,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8202,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8252,
        "carrierId": "USXI"
    },
    {
        "dc": 4964,
        "club": 8253,
        "carrierId": "KNIG"
    },
    {
        "dc": 4964,
        "club": 8283,
        "carrierId": "USXI"
    },
    {
        "dc": 4965,
        "club": 4714,
        "carrierId": "POQC"
    },
    {
        "dc": 4965,
        "club": 4731,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 4761,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 4791,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 4839,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 4938,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 4961,
        "carrierId": "WERE"
    },
    {
        "dc": 4965,
        "club": 6238,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 6267,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 6275,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 6342,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 6408,
        "carrierId": "WERE"
    },
    {
        "dc": 4965,
        "club": 6672,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 6779,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 7189,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 7676,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 8117,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 8239,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 8241,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 8254,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 8263,
        "carrierId": "KNIG"
    },
    {
        "dc": 4965,
        "club": 8279,
        "carrierId": "WM"
    },
    {
        "dc": 4965,
        "club": 8289,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 4741,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 4875,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 4876,
        "carrierId": "PASC"
    },
    {
        "dc": 4966,
        "club": 4878,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 4908,
        "carrierId": "PASC"
    },
    {
        "dc": 4966,
        "club": 4951,
        "carrierId": "POQC"
    },
    {
        "dc": 4966,
        "club": 4999,
        "carrierId": "PASC"
    },
    {
        "dc": 4966,
        "club": 6252,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 6334,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 6449,
        "carrierId": "KNIG"
    },
    {
        "dc": 4966,
        "club": 6474,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 6479,
        "carrierId": "KNIG"
    },
    {
        "dc": 4966,
        "club": 6512,
        "carrierId": "KNIG"
    },
    {
        "dc": 4966,
        "club": 8123,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8125,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8135,
        "carrierId": "PASC"
    },
    {
        "dc": 4966,
        "club": 8180,
        "carrierId": "PASC"
    },
    {
        "dc": 4966,
        "club": 8182,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8197,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8205,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8215,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8251,
        "carrierId": "WM"
    },
    {
        "dc": 4966,
        "club": 8257,
        "carrierId": "KNIG"
    },
    {
        "dc": 4966,
        "club": 8285,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 4736,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 4738,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 4787,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 4933,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 4937,
        "carrierId": "POQC"
    },
    {
        "dc": 4968,
        "club": 6254,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6309,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6310,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6311,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6312,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6320,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 6321,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6385,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 6427,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 6432,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 6436,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6510,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6514,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6535,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 6568,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 8149,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 8162,
        "carrierId": "WM"
    },
    {
        "dc": 4968,
        "club": 8165,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 8172,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 8183,
        "carrierId": "AQSM"
    },
    {
        "dc": 4968,
        "club": 8185,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 4703,
        "carrierId": "KNIG"
    },
    {
        "dc": 6299,
        "club": 4732,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 4784,
        "carrierId": "KNIG"
    },
    {
        "dc": 6299,
        "club": 4829,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 4830,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 4915,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 4955,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6205,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6213,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6246,
        "carrierId": "WERE"
    },
    {
        "dc": 6299,
        "club": 6257,
        "carrierId": "KNIG"
    },
    {
        "dc": 6299,
        "club": 6261,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6347,
        "carrierId": "KNIG"
    },
    {
        "dc": 6299,
        "club": 6502,
        "carrierId": "WERE"
    },
    {
        "dc": 6299,
        "club": 6604,
        "carrierId": "KNIG"
    },
    {
        "dc": 6299,
        "club": 6605,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6606,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6608,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 6692,
        "carrierId": "WM"
    },
    {
        "dc": 6299,
        "club": 8153,
        "carrierId": "WERE"
    },
    {
        "dc": 6299,
        "club": 8177,
        "carrierId": "KNIG"
    },
    {
        "dc": 6299,
        "club": 8280,
        "carrierId": "WERE"
    },
    {
        "dc": 6492,
        "club": 4729,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 4750,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 4771,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 4846,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 4847,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 4859,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 4860,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 4936,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 4947,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 4952,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6251,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 6302,
        "carrierId": "PAMT"
    },
    {
        "dc": 6492,
        "club": 6305,
        "carrierId": "PAMT"
    },
    {
        "dc": 6492,
        "club": 6307,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 6317,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6322,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 6326,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6327,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 6357,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6365,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 6371,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 6373,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6404,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6406,
        "carrierId": "WERE"
    },
    {
        "dc": 6492,
        "club": 6434,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6457,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6460,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6533,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 6556,
        "carrierId": "WM"
    },
    {
        "dc": 6492,
        "club": 6575,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6650,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6651,
        "carrierId": "USXI"
    },
    {
        "dc": 6492,
        "club": 6652,
        "carrierId": "PAMT"
    },
    {
        "dc": 6492,
        "club": 6653,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6655,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6673,
        "carrierId": "WERE"
    },
    {
        "dc": 6492,
        "club": 6675,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 6677,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6678,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 6679,
        "carrierId": "AWLO"
    },
    {
        "dc": 6492,
        "club": 8189,
        "carrierId": "SWFT"
    },
    {
        "dc": 6492,
        "club": 8193,
        "carrierId": "PAMT"
    },
    {
        "dc": 6493,
        "club": 4704,
        "carrierId": "SWFT"
    },
    {
        "dc": 6493,
        "club": 4709,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 4735,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 4767,
        "carrierId": "WMT"
    },
    {
        "dc": 6493,
        "club": 4768,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 4799,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 4819,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 4822,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 4824,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 4974,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 4983,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 6235,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 6240,
        "carrierId": "WMT"
    },
    {
        "dc": 6493,
        "club": 6378,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6382,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 6405,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 6405,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 6433,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 6455,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 6522,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6609,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 6610,
        "carrierId": "WMT"
    },
    {
        "dc": 6493,
        "club": 6612,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 6613,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 6614,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6615,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6616,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6617,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6619,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6620,
        "carrierId": "SWFT"
    },
    {
        "dc": 6493,
        "club": 6621,
        "carrierId": "KNIG"
    },
    {
        "dc": 6493,
        "club": 6622,
        "carrierId": "SWFT"
    },
    {
        "dc": 6493,
        "club": 6624,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 6626,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 6628,
        "carrierId": "WM"
    },
    {
        "dc": 6493,
        "club": 8799,
        "carrierId": "LGSB"
    },
    {
        "dc": 6493,
        "club": 9476,
        "carrierId": "LGSB"
    },
    {
        "dc": 6494,
        "club": 4718,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 4730,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 4745,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 4770,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 4777,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 4786,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 4805,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 4816,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 4853,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 4987,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6219,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6345,
        "carrierId": "SWFT"
    },
    {
        "dc": 6494,
        "club": 6360,
        "carrierId": "SWFT"
    },
    {
        "dc": 6494,
        "club": 6379,
        "carrierId": "SWFT"
    },
    {
        "dc": 6494,
        "club": 6425,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6430,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6549,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6565,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 6630,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6631,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6632,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6633,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6634,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6635,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6682,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 6683,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6684,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 6685,
        "carrierId": "KNIG"
    },
    {
        "dc": 6494,
        "club": 6686,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 8147,
        "carrierId": "WM"
    },
    {
        "dc": 6494,
        "club": 8272,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 4724,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 4739,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 4780,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 4789,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 4802,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 4804,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 4817,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 4836,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 4901,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 4930,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 4950,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 4989,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 4993,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 6409,
        "carrierId": "PAMT"
    },
    {
        "dc": 6499,
        "club": 6452,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 6463,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 6501,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 6509,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 6518,
        "carrierId": "PAMT"
    },
    {
        "dc": 6499,
        "club": 6572,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 6643,
        "carrierId": "PAMT"
    },
    {
        "dc": 6499,
        "club": 6644,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 6646,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 8112,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 8115,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 8158,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 8166,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 8194,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 8203,
        "carrierId": "PAMT"
    },
    {
        "dc": 6499,
        "club": 8211,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 8213,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 8222,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 8225,
        "carrierId": "WM"
    },
    {
        "dc": 6499,
        "club": 8247,
        "carrierId": "PASC"
    },
    {
        "dc": 6499,
        "club": 8256,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 8278,
        "carrierId": "AQSM"
    },
    {
        "dc": 6499,
        "club": 8287,
        "carrierId": "AQSM"
    },
    {
        "dc": 6596,
        "club": 4778,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 4781,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 4944,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 4962,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 4982,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6242,
        "carrierId": "SWFT"
    },
    {
        "dc": 6596,
        "club": 6314,
        "carrierId": "SWFT"
    },
    {
        "dc": 6596,
        "club": 6319,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 6359,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 6375,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6407,
        "carrierId": "SWFT"
    },
    {
        "dc": 6596,
        "club": 6412,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6417,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6419,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6429,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6454,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6562,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6657,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 6658,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6659,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 6660,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6661,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 6662,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6663,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6664,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 6666,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 6667,
        "carrierId": "WM"
    },
    {
        "dc": 6596,
        "club": 8139,
        "carrierId": "USXI"
    },
    {
        "dc": 6596,
        "club": 8291,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4109,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4702,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4712,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4713,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4721,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4763,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4764,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4769,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 4843,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 6202,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 6338,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 6367,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 6421,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 6422,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 6867,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8190,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8244,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8245,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8246,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8265,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8273,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8274,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8275,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8281,
        "carrierId": "WM"
    },
    {
        "dc": 6698,
        "club": 8284,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 4707,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 4870,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 4873,
        "carrierId": "KNIG"
    },
    {
        "dc": 7667,
        "club": 4920,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 6181,
        "carrierId": "HLBO"
    },
    {
        "dc": 7667,
        "club": 6247,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 6344,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 6413,
        "carrierId": "HLBO"
    },
    {
        "dc": 7667,
        "club": 6415,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 6418,
        "carrierId": "KNIG"
    },
    {
        "dc": 7667,
        "club": 6426,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 6461,
        "carrierId": "HLBO"
    },
    {
        "dc": 7667,
        "club": 6472,
        "carrierId": "HLBO"
    },
    {
        "dc": 7667,
        "club": 6505,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 6979,
        "carrierId": "HLBO"
    },
    {
        "dc": 7667,
        "club": 6979,
        "carrierId": "KNIG"
    },
    {
        "dc": 7667,
        "club": 8146,
        "carrierId": "HLBO"
    },
    {
        "dc": 7667,
        "club": 8163,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 8176,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 8207,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 8208,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 8243,
        "carrierId": "WM"
    },
    {
        "dc": 7667,
        "club": 8293,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 4710,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 4711,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 4797,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 4798,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 4831,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 4917,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 4946,
        "carrierId": "TTMS"
    },
    {
        "dc": 8206,
        "club": 4996,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 6216,
        "carrierId": "TTMS"
    },
    {
        "dc": 8206,
        "club": 6236,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6343,
        "carrierId": "SWFT"
    },
    {
        "dc": 8206,
        "club": 6348,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 6351,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6353,
        "carrierId": "KNIG"
    },
    {
        "dc": 8206,
        "club": 6354,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6355,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6368,
        "carrierId": "TTMS"
    },
    {
        "dc": 8206,
        "club": 6402,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6414,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6443,
        "carrierId": "TTMS"
    },
    {
        "dc": 8206,
        "club": 6458,
        "carrierId": "TTMS"
    },
    {
        "dc": 8206,
        "club": 6524,
        "carrierId": "SWFT"
    },
    {
        "dc": 8206,
        "club": 6540,
        "carrierId": "USXI"
    },
    {
        "dc": 8206,
        "club": 6569,
        "carrierId": "SWFT"
    },
    {
        "dc": 8206,
        "club": 6570,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 6571,
        "carrierId": "KNIG"
    },
    {
        "dc": 8206,
        "club": 6573,
        "carrierId": "TTMS"
    },
    {
        "dc": 8206,
        "club": 6976,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8129,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8142,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8218,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8219,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8220,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8223,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 8228,
        "carrierId": "WM"
    },
    {
        "dc": 8206,
        "club": 9639,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4772,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 4782,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 4785,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4794,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 4801,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4818,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4828,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4852,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4857,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 4861,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 4972,
        "carrierId": "TTMS"
    },
    {
        "dc": 8229,
        "club": 4991,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 4998,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 6189,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 6212,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 6217,
        "carrierId": "PAMT"
    },
    {
        "dc": 8229,
        "club": 6218,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 6253,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 6341,
        "carrierId": "PAMT"
    },
    {
        "dc": 8229,
        "club": 6364,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 6387,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 6401,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 6403,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 6420,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 6441,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 6445,
        "carrierId": "TTMS"
    },
    {
        "dc": 8229,
        "club": 6448,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 6520,
        "carrierId": "TTMS"
    },
    {
        "dc": 8229,
        "club": 6637,
        "carrierId": "WM"
    },
    {
        "dc": 8229,
        "club": 7191,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 8130,
        "carrierId": "TTMS"
    },
    {
        "dc": 8229,
        "club": 8141,
        "carrierId": "TTMS"
    },
    {
        "dc": 8229,
        "club": 8150,
        "carrierId": "TTMS"
    },
    {
        "dc": 8229,
        "club": 8157,
        "carrierId": "PAMT"
    },
    {
        "dc": 8229,
        "club": 8173,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 8201,
        "carrierId": "SDCK"
    },
    {
        "dc": 8229,
        "club": 8290,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 4041,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 4722,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 4774,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 4855,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 4994,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6201,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6239,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6330,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6332,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6333,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6352,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6356,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6366,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6369,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6383,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6386,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6423,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6428,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6431,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6440,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6456,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6462,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6490,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 6536,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6539,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6547,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6567,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6581,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6636,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6670,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6671,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6674,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 6676,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 6693,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 8144,
        "carrierId": "KAEJ"
    },
    {
        "dc": 8231,
        "club": 8145,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 8160,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 8161,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 8175,
        "carrierId": "WM"
    },
    {
        "dc": 8231,
        "club": 8186,
        "carrierId": "PAMT"
    },
    {
        "dc": 8231,
        "club": 8191,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 4728,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 4851,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 4926,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 4963,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 4992,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 6304,
        "carrierId": "PLCY"
    },
    {
        "dc": 8232,
        "club": 6308,
        "carrierId": "PAMT"
    },
    {
        "dc": 8232,
        "club": 6313,
        "carrierId": "PAMT"
    },
    {
        "dc": 8232,
        "club": 6325,
        "carrierId": "PAMT"
    },
    {
        "dc": 8232,
        "club": 6380,
        "carrierId": "PAMT"
    },
    {
        "dc": 8232,
        "club": 6424,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 6437,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 6450,
        "carrierId": "PASC"
    },
    {
        "dc": 8232,
        "club": 6517,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 6528,
        "carrierId": "PASC"
    },
    {
        "dc": 8232,
        "club": 8111,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 8132,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 8133,
        "carrierId": "PASC"
    },
    {
        "dc": 8232,
        "club": 8136,
        "carrierId": "PASC"
    },
    {
        "dc": 8232,
        "club": 8152,
        "carrierId": "PAMT"
    },
    {
        "dc": 8232,
        "club": 8168,
        "carrierId": "PLCY"
    },
    {
        "dc": 8232,
        "club": 8188,
        "carrierId": "PASC"
    },
    {
        "dc": 8232,
        "club": 8276,
        "carrierId": "WM"
    },
    {
        "dc": 8232,
        "club": 9475,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 4026,
        "carrierId": "POQC"
    },
    {
        "dc": 8234,
        "club": 4740,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 4749,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 4776,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 4808,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 4813,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 4825,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 4969,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 4985,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 6249,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 6256,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 6260,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 6329,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 6377,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 6507,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 8104,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8107,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8134,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8196,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8209,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8237,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8266,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8292,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 8294,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 8295,
        "carrierId": "PPRK"
    },
    {
        "dc": 8234,
        "club": 8295,
        "carrierId": "WM"
    },
    {
        "dc": 8234,
        "club": 8296,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4742,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4743,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4783,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4795,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4905,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4906,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4911,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 4925,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6244,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6255,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6265,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6350,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6372,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6376,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6381,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6482,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6511,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 6781,
        "carrierId": "TTMS"
    },
    {
        "dc": 8235,
        "club": 6845,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8101,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8210,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8224,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8226,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8242,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8248,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8268,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8269,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8270,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8277,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8282,
        "carrierId": "WM"
    },
    {
        "dc": 8235,
        "club": 8299,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 4815,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 4840,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 4942,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 4973,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 6228,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 6315,
        "carrierId": "WENI"
    },
    {
        "dc": 8307,
        "club": 6324,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 6328,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 6331,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 6339,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 6349,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 6358,
        "carrierId": "USXI"
    },
    {
        "dc": 8307,
        "club": 6384,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 6388,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 6444,
        "carrierId": "USXI"
    },
    {
        "dc": 8307,
        "club": 6464,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 6485,
        "carrierId": "USXI"
    },
    {
        "dc": 8307,
        "club": 6487,
        "carrierId": "USXI"
    },
    {
        "dc": 8307,
        "club": 6489,
        "carrierId": "USXI"
    },
    {
        "dc": 8307,
        "club": 6504,
        "carrierId": "USXI"
    },
    {
        "dc": 8307,
        "club": 8128,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 8164,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 8167,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 8169,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 8174,
        "carrierId": "WENI"
    },
    {
        "dc": 8307,
        "club": 8184,
        "carrierId": "LGSB"
    },
    {
        "dc": 8307,
        "club": 8238,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 8297,
        "carrierId": "WM"
    },
    {
        "dc": 8307,
        "club": 8298,
        "carrierId": "WM"
    }
]

export default filterCodes